export default __webpack_public_path__ + "static/media/open-chevron.fc332b88.svg";